$(document).ready(function () {
        // Initially open accordions based on the 'open-accordion' class
        $('.acc-head.open-accordion').each(function () {
        $(this).siblings('.acc-content').slideDown();
        $(this).addClass('active');
        });
        
        $('.acc-head').on('click', function () {
        if ($(this).hasClass('active')) {
          // If the accordion is currently open, close it and remove the 'active' class
          $(this).siblings('.acc-content').slideUp();
          $(this).removeClass('active');
        } else {
          // If the accordion is currently closed, close all others and open this one
          $('.acc-content').slideUp();
          $('.acc-head').removeClass('active');
          $(this).siblings('.acc-content').slideDown();
          $(this).addClass('active');
        }
        });
        });
// Trust Pilot code
          $(document).ready(function(){
              $(".trust_main").insertAfter(".reviews--");
                 $('.owl-carousel').owlCarousel({
                   items: 2,
                     loop: true,
                     autoplay: true,
                     autoplayTimeout: 5000, // Set the autoplay interval in milliseconds
                     autoplayHoverPause: true, // Pause autoplay when hovering over the carousel
                     nav: true, // Show navigation buttons
                     dots: false,
                     responsive: {
                           0: {
                             items: 1,
                              center: true,
                         },
                         1200: {
                             items: 2
                         }
                     }

                 });
            $( ".owl-prev").html('<i class="fas fa-arrow-circle-left" style="color: #acadaf;"></i>');
      $( ".owl-next").html('<i class="fas fa-arrow-circle-right" style="color: #acadaf;"></i>');
             });
